import React from 'react';
import { useState } from 'react';
import PropTypes from 'prop-types';

import { getFromLocalStorage } from '@cuemath/intel';
import SpeedTestHandler from 'modules/speed-test/handler';

export default function SpeedTest(props) {
  const { teacherClassroomId, userId } = props;
  const [speedTestDone, setSpeedTestDone] = useState(false);

  const lastTeacherClassroomIdSpeedTestDone =
    getFromLocalStorage(`TeacherClassroomIdSpeedTestDone`) || null;

  const isSpeedTestDone = value => {
    setSpeedTestDone(value);
  };

  return (
    <>
      {teacherClassroomId &&
        !speedTestDone &&
        lastTeacherClassroomIdSpeedTestDone !== teacherClassroomId && (
          <SpeedTestHandler
            isSpeedTestDone={isSpeedTestDone}
            teacherClassroomId={teacherClassroomId}
            userId={userId}
          />
        )}
    </>
  );
}

SpeedTest.propTypes = {
  teacherClassroomId: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
};
